var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-info" }, [
    _c("div", { staticClass: "input_div" }, [
      _c("div", [_vm._v("当前案例：")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.event_info.sample_name,
              expression: "event_info.sample_name"
            }
          ],
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.event_info,
                "sample_name",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            }
          }
        },
        _vm._l(_vm.sample_list, function(v, idx) {
          return _c("option", { key: idx, domProps: { value: v } }, [
            _vm._v(_vm._s(v) + "\n            ")
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input_div" }, [
      _c("div", [_vm._v("事件A：")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.event_info.event_A,
            expression: "event_info.event_A",
            modifiers: { lazy: true }
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.event_info.event_A },
        on: {
          change: function($event) {
            return _vm.$set(_vm.event_info, "event_A", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input_div" }, [
      _c("div", [_vm._v("事件B：")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.event_info.event_B,
            expression: "event_info.event_B",
            modifiers: { lazy: true }
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.event_info.event_B },
        on: {
          change: function($event) {
            return _vm.$set(_vm.event_info, "event_B", $event.target.value)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }